import { useState } from 'react'

const useShowBalance = () => {
  const [show, setShow] = useState(false)
  return { show, setShow }
}

export default useShowBalance
